import React from 'react'
import { renderToStaticMarkup } from 'react-dom/server'

export default function getTranslatedOrStringValue(
  rawString: any,
  i18n: { _: Function }
): String | null {
  if (typeof rawString === 'object' && rawString !== null) {
    const {
      props: {
        id: transId = null,
        dangerouslySetInnerHTML: { __html: htmlString = null } = {}
      } = {}
    } = rawString

    if (htmlString) {
      return getTranslatedOrStringValue(htmlString, i18n)
    }
    if (transId) {
      return i18n._(transId)
    }
    if (React.isValidElement(rawString)) {
      return renderToStaticMarkup(rawString)
    }

    return rawString.toString()
  }

  return rawString
}
